export const CLIENTS_PAGE = {
    'CLIENTS.PAGE.TITLE': 'Clienți KPMG',
    'CLIENT.ADD.MODAL.TITLE': 'Client nou',
    'CLIENT.EDIT.MODAL.TITLE': 'Editare client'
};
